<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="$tt('充电站:')" :label-width="100">
				<Select filterable :placeholder="$tt('站点列表')" style="width: 200px;" v-model="formInline.StationId">
					<Option :value="0">{{$tt('全部')}}</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName" :label="$tt('设备编号:')" :label-width="100">
				<Input type="text" v-model="formInline.EquipmentNo" :placeholder="$tt('设备编号')" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			</FormItem>
			<FormItem>
				<Upload :headers="upHeader" name="UpFile" :show-upload-list="false" :on-error="handleError"
					:on-format-error="handleFormatError" :on-success="handleSuccess" :format="['xlsx']"
					:before-upload="beforeUpload" :data='formInline' :action="importDataToEquipmentUrl"
					v-if="hasWidgets('import')">
					<Button icon="ios-cloud-upload-outline">{{$tt('批量导入')}}</Button>
				</Upload>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('add')" v-if="hasWidgets('add')">{{$tt('新建设备')}}</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">{{$tt('批量导入')}}</Button> -->
			</div>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight" size="small"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getEquipmentInfoUrl" @listData='getDeviceData'></MyPage>
		<Modal v-model="modalView" :title="modal.Title" width="75%" :mask-closable="false" :closable="false">
			<!-- 设备安装和设备修改 -->
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='add'||modal.type=='update'||modal.type=='view'" ref="FormEquip" :model="FormEquip"
				:label-width="150">
				<Row>
					<Col span=7>
					<FormItem :label="$tt('设备编号')" prop="EquipNo">
						<Input :disabled="!ifAddEquipment" v-model="FormEquip.EquipNo" :placeholder="$tt('输入设备编号')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="$tt('设备名称')" prop="EquipName">
						<Input :disabled="ifViewStation" v-model="FormEquip.EquipName" :placeholder="$tt('输入设备名称')"></Input>
					</FormItem>
					</Col>
					<!-- <Col span=7>
					<FormItem :label="$tt('所属主设备编号')" prop="MasterEquip">
						<Input :disabled="ifViewStation" v-model="FormEquip.MasterEquip"
							:placeholder="$tt('输入所属主设备编号')"></Input>
					</FormItem>
					</Col> -->
				</Row>
				<Row>
					<Col span=7>
					<FormItem :label="$tt('生产商组织机构代码')" prop="ManufacturerId">
						<Input :disabled="ifViewStation" v-model="FormEquip.ManufacturerId"
							:placeholder="$tt('输入设备生产商组织机构代码')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="$tt('生产商名称')" prop="ManufacturerName">
						<Input :disabled="ifViewStation" v-model="FormEquip.ManufacturerName"
							:placeholder="$tt('输入设备生产商名称')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span=7>
					<FormItem :label="$tt('所属场站')" prop="StationId">
						<Select filterable :disabled="ifViewStation" :placeholder="$tt('所属场站')" v-model="FormEquip.StationId">
							<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="$tt('设备型号')" prop="EquipModel">
						<Input disabled v-model="FormEquip.EquipModel" :placeholder="$tt('输入设备型号')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="$tt('设备状态')" prop="EquipStatus">
						<Select :disabled="ifViewStation"  :placeholder="$tt('设备状态')" v-model="FormEquip.EquipStatus">
							<Option :value="1">{{$tt('建设中')}}</Option>
							<Option :value="5">{{$tt('关闭下线(停用)')}}</Option>
							<Option :value="6">{{$tt('维护中')}}</Option>
							<Option :value="50">{{$tt('正常使用')}}</Option>
							<Option :value="51">{{$tt('其他')}}</Option>
						</Select>
					</FormItem>
					</Col>
					<!-- <Col span=7>
					<FormItem :label="$tt('生产日期')" prop="ProductionDate">
						<Input :disabled="ifViewStation" v-model="FormEquip.ProductionDate" :placeholder="$tt('输入生产日期')"></Input>
					</FormItem>
					</Col> -->
				</Row>
				<Row>
					<Col span=7>
					<FormItem :label="$tt('硬件版本')" prop="HardVersion">
						<Input disabled v-model="FormEquip.HardVersion" :placeholder="$tt('输入硬件版本')"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem :label="$tt('软件版本')" prop="SoftVersion">
						<Input disabled v-model="FormEquip.SoftVersion" :placeholder="$tt('输入软件版本')"></Input>
					</FormItem>
					</Col>
					<!-- <Col span=7>
					<FormItem :label="$tt('生产批次')" prop="ProductionBatch">
						<Input :disabled="ifViewStation" v-model="FormEquip.ProductionBatch"
							:placeholder="$tt('输入生产批次')"></Input>
					</FormItem>
					</Col> -->
				</Row>
			</Form>
			<Button type="primary" v-if="modal.type=='add'" @click="addLock" size="small" shape="circle"
					icon="md-add">{{$tt('添加')}}</Button>
			<Button type="primary" v-if="modal.type=='add'" @click="delLock" size="small" shape="circle"
				icon="ios-trash">{{$tt('删除')}}</Button>
			<Table :columns="columnsLock" :data="FormEquip.ParkingLocks" size="small"></Table>
			
			<div v-if="modal.type!='addExcel'" slot="footer">
				<Button type="warning" size="large" @click="modalCancel">{{$tt('取消')}}</Button>
				<Button v-if="modal.type=='add' || modal.type=='update'" type="success" size="large"
					@click="modalOk(modal.type)">{{$tt('确定')}}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	// import dateFormat from '../../../../public/js/comm.js'
	import expandRow from './EquipmentManagementParkingLockExpand.vue';
	// import gaodeMap from '../../../js/GaodeMapMethod.js'
	import {
		mapState,
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		data() {
			const validateParkingLocksNum = (rule, value, callback) => {
				if (value.length == 0) {
					callback(new Error(this.$tt('请添加地锁之后保存')));
				} else {
					callback();
				}
			};
			return {
				importDataToEquipmentUrl: webapi.base_api_url + '/Archives/ImportEquipmentParkingLock',
				getEquipmentInfoUrl: webapi.base_api_url + '/Archives/GetEquipParkingLockInfo',
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "",
				tableHeight: "650",
				modal: {
					Title: this.$tt('信息添加'),
					type: "add"
				},
				modalView: false,
				//地图modal
				showMap: false,
				center: [114.198595, 22.633595],
				zindex: 1100,
				//是否新增操作
				ifAddEquipment: true,
				// 是否修改操作
				ifUpdateEquip: false,
				//信息是否只能查看
				ifViewStation: false,
				
				//档案-场站管理全部信息
				FormEquip: {
					EquipNo: "",
					EquipName: "",
					MasterEquip: "",
					EquipModel: "",
					ManufacturerId: "",
					ManufacturerName: "",
					ProductionDate: "",
					ProductionBatch: "",
					SoftVersion: "",
					HardVersion: "",
					EquipStatus: 50,
					StationId: '',
					ParkingLocks: [],
					IsEdit: false
				},
				//校验字段
				ruleInline: {
					EquipNo: [{
						required: true,
						message: this.$tt('设备编号'),
						trigger: 'blur'
					}],
					EquipName: [{
						required: true,
						message: this.$tt('设备名称'),
						trigger: 'blur'
					}],
					StationId: [{
						required: true,
						message: this.$tt('所属场站'),
						trigger: 'change',
						type: 'number'
					}],
					// EquipModel: [{
					// 	required: true,
					// 	message: this.$tt('设备型号模板'),
					// 	trigger: 'change',
					// }],
					ParkingLocks: [{
						validator: validateParkingLocksNum,
						trigger: 'blur',
					}]
				},
				//当前选中的设备模板的信息
				selectModel: [],
				BreadcrumbList: [this.$tt('档案管理'), '>>', this.$tt('设备管理')],
				formInline: {
					StationId: 0,
					EquipmentNo: ''
				},
				
				//table标题数据
				columns1: [{
						type: 'expand',
						width: 30,
						render: (h, params) => {
							return h(expandRow, {
								props: {
									row: params.row
								}
							})
						}
					}, {
						title: this.$tt('设备编号'),
						key: 'EquipNo',
						width: 150,
					}, {
						title: this.$tt('设备名称'),
						key: 'EquipName',
						width: 100,
					}, {
						title: this.$tt('所属主设备编号'),
						key: 'MasterEquip',
						width: 100,
					},
					{
						title: this.$tt('设备型号'),
						key: 'EquipModel',
						width: 120
					},
					{
						title: this.$tt('设备生产商名称'),
						key: 'ManufacturerName',
						width: 200
					},
					{
						title: this.$tt('所属场站'),
						key: 'StationId',
						width: 200,
						render: (h, params) => {
							return h('div', params.row.StationName)
						}
					},
					{
						title: this.$tt('设备状态'),
						key: 'EquipStatusDesc',
						width: 100,
					},
					{
						title: this.$tt('建档时间'),
						key: 'CreateTime',
						width: 120,
					},
					{
						title: this.$tt('操作'),
						key: 'action',
						width: 230,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row)
										}
									}
								}, this.$tt('修改')) : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("view", params.row)
										}
									}
								}, this.$tt('查看')) : h(),
							// 	this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h(
							// 		'Dropdown', {
							// 			on: {
							// 				//为了不误操作，确定取消相反
							// 				'on-click': (name) => {
							// 					this.$Modal.confirm({
							// 						title: name,
							// 						okText: '取消',
							// 						cancelText: '确定',
							// 						onCancel: () => {
							// 							this.otherMethod(name, params.row
							// 								.EquipmentNo);
							// 						}
							// 					});
							// 					// this.show("deleteStation", params.row.Id)
							// 				}
							// 			}
							// 		},
							// 		[
							// 			h('Button', {
							// 				props: {
							// 					type: 'primary',
							// 					size: 'small',
							// 				},
							// 				style: {
							// 					marginRight: '5px'
							// 				},
							// 			}, this.$tt('其他操作')),
							// 			h('DropdownMenu', {
							// 				slot: 'list'
							// 			}, [
							// 				this.methodList.filter(item => this.hasWidgets(item.name))
							// 				.map((
							// 					item) => { // this.productTypeList下拉框里的data
							// 					return h('DropdownItem', {
							// 							props: {
							// 								name: item.Status
							// 							}
							// 						},
							// 						item.Status
							// 					)
							// 				})
							// 			])
							// 		],
							// 	) : h()
							]);
						}
					}
				],
				columnsLock: [
					{
						title: this.$tt('地锁编号'),
						key: 'LockNo',
						width: 150,
					},
					{
						title: this.$tt('地锁名称'),
						key: 'LockName',
						render: (h, params) => {
							console.log('params: ', params, params.row[params.column.key])
							const _this = this
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 60))
						}
					},
					{
						title: this.$tt('车位号'),
						key: 'ParkNo',
						render: (h, params) => {
							console.log('params: ', params, params.row[params.column.key])
							const _this = this
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 60))
						}
					},
					{
						title: this.$tt('备注'),
						key: 'remark',
						render: (h, params) => {
							console.log('params: ', params, params.row[params.column.key])
							const _this = this
							if (this.ifViewStation) {
								return h('div', params.row[params.column.key])
							}
							return h('Input', this.tableCellEditor(this, params, 60))
						}
					}
				],
				data1: [],
				methodList: [{
						id: 1,
						name: 'building',
						Status: this.$tt('建设中')
					}, {
						id: 5,
						name: 'swithcOff',
						Status: this.$tt('关闭下线')
					},
					{
						id: 6,
						name: 'maintaining',
						Status: this.$tt('维护中')
					},
					{
						id: 50,
						name: 'running',
						Status: this.$tt('正常使用')
					}
				],
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			const operateColumnWidth = Math.max(60, (36 + (this.hasWidgets('edit') ? 60 : 0) + (this.hasWidgets('view') ?
					60 : 0) +
				(this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? 80 : 0)));
			// 不用 .at(-1)：Array.prototype.at 是 ES2022 方法，老浏览器（Chrome < 92 / Safari < 15.4）不支持
			this.columns1[this.columns1.length - 1].minWidth = operateColumnWidth;
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					EquipmentNo: _this.formInline.EquipmentNo
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
				EquipmentModelDefine: 'EquipmentModelDefine'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			// //设备添加预设值
			// modelDefine: function(modelValue) {
			// 	const _this = this
			// 	console.log("1111111111111")
			// 	if (modelValue != undefined) {
			// 		console.log("2222222222222")
			// 		_this.selectModel = _this.EquipmentModelDefine.filter(function(model) {
			// 			return model.ModelId == modelValue
			// 		});
			// 		for (let var1 in _this.FormEquip) {
			// 			if (_this.selectModel[0].Equipment[var1] != undefined) {
			// 				_this.FormEquip[var1] = _this.selectModel[0].Equipment[var1]
			// 			}
			// 		}
			// 	}
			// },
			//删除修改之外的其他操作
			otherMethod: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).id
				console.log(typeNum)
				this.$axios.post(webapi.base_api_url + "/Archives/SetEquipmentStatus", {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(name + this.$tt('成功'));
						this.$refs.sonPage.getList();
					}
				})
			},
			tableCellEditor(_this, params, width) {
				return {
					style: {
						width: width + 'px'
					},
					props: {
						clearable: false,
						type: 'text',
						value: params.row[params.column.key]
					},
					on: {
						'on-blur': event => {
							// params.row[params.column.key] = event.target.value
							_this.FormEquip.ParkingLocks[params.index][params.column.key] = event.target.value
						}
					}
				}
			},

			//操作
			show: function(type, rowInfo) {
				this.ifAddEquipment = false;
				this.ifViewStation = false;
				this.ifUpdateEquip = true;
				switch (type) {
					case "add":
						this.modal.type = "add";
						this.modal.Title = this.$tt('信息添加');
						this.ifAddEquipment = true
						this.$refs.FormEquip.resetFields();
						this.selectModel = []
						this.FormEquip = {
							EquipNo: "",
							EquipName: "",
							MasterEquip: "",
							EquipModel: "",
							ManufacturerId: "",
							ManufacturerName: "",
							ProductionDate: "",
							ProductionBatch: "",
							SoftVersion: "",
							HardVersion: "",
							EquipStatus: 50,
							StationId: '',
							ParkingLocks: [],
							IsEdit: false
						}
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = this.$tt('信息修改');
						this.getUpdateMessage(rowInfo);
						this.ifUpdateEquip = true;
						//this.ifViewStation=false
						break;
					case "view":
						this.modal.type = "view";
						this.modal.Title = this.$tt('信息查看');
						this.getUpdateMessage(rowInfo);
						this.ifViewStation = true
						break;
				}
				this.modalView = true;
			},
			getDeviceData: function(data) {
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			modalCancel: function() {
				if (this.modal.type === "install") {
					//this.$refs.InstallForm.resetFields();
				} else if (this.modal.type === "add" || this.modal.type === "update" || this.modal.type === "view") {
					this.$refs.FormEquip.resetFields();
					this.modalView = false
				}
			},
			deepClone(params) {
				// 如果数组类型数据
				if (Array.isArray(params)) {
					let newnew = []
					for (let i = 0; i < params.length; i++) {
						newnew[i] = this.deepClone(params[i]) // 递归调用克隆
					}
					return newnew // 克隆完以后，再返回出结果
				}
				// 如果是对象类型数据
				if (Object.prototype.toString.call(params) === '[object Object]') {
					let newnew = {}
					for (const key in params) {
						newnew[key] = this.deepClone(params[key]) // 递归调用克隆
					}
					return newnew // 克隆完以后，再返回出结果
				}
				// 如果是普通数据类型
				return params
			},
			getUpdateMessage: function(equipInfo) {
				console.log(equipInfo);
				const _this = this;
				_this.FormEquip = {};
				_this.FormEquip = _this.deepClone(equipInfo);
			},
			modalOk: function(type) {
				const _this = this
				let url = '';
				switch (type) {
					case "add":
						_this.FormEquip.IsEdit = false;
						url = webapi.base_api_url + '/Archives/AddParkingLock'
						break;
					case "update":
						_this.FormEquip.IsEdit = true
						url = webapi.base_api_url + '/Archives/ModifyParkingLock'
						break;
				}
				//没定必填项
				_this.$refs.FormEquip.validate((valid) => {
					console.log("设备" + type + "----" + valid)
					if (valid) {
						const param = _this.FormEquip
						_this.$axios.post(url, param).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								_this.$Message.info(this.$tt('设备') + type + this.$tt('成功'));
								_this.$refs.sonPage.getList();
								this.modalView = false;
							} else {
								_this.$Message.info(this.$tt('设备') + type + this.$tt('失败:') + res.data.Data);
							}
						})
					}
				})
			},
			// mapOpen: function() {
			// 	this.showMap = true;
			// 	gaodeMap.initMap("map", 10, this.center, 'normal');
			// 	gaodeMap.mapOn(this);
			// },
			// closeMap: function() {
			// 	gaodeMap.map.destroy();
			// 	gaodeMap.map = '';
			// 	this.showMap = false;
			// },
			beforeUpload(file) {
				const _this = this
				if (_this.formInline.StationId != 0) {
					let stationName = ''
					_this.StationList.forEach(function(item) {
						console.log(item);
						if (item.StationId == _this.formInline.StationId) {
							stationName = item.StationName
						}
					})
					let p = new Promise(function(resolve, reject) {
						_this.$Modal.confirm({
							title: this.$tt('添加设备的场站-->') + stationName,
							okText: this.$tt('取消'),
							cancelText: this.$tt('确定'),
							onCancel: () => {
								resolve()
							},
							onOk: () => {
								reject()
							}
						});
					})
					return p
				} else {
					this.$Message.success(this.$tt('请在左侧选择具体场站！！！'));
					return false
				}
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$tt('文件格式错误'),
					desc: '文件' + file.name + this.$tt('请上传xlsx格式文件')
				});
			},
			handleSuccess(res, file) {
				this.$Message.success(this.$tt('导入结果：') + res.Msg + "---" + res.Data);
				this.handleSubmit()
			},
			handleError(error, file) {
				this.$Message.success(this.$tt('导入错误'));
			},
			addLock() {
				const _this = this
					if (_this.FormEquip.EquipNo == "") {
						_this.$Message.warning(this.$tt('请填写设备编号'));
						return;
					}
					{
						let lockTemplate = {
							LockNo: '',
							LockName: '',
							LockType: 0,
							ParkNo: '',
							EquipNo: '',
							Remarks: '',
						};
						const LockIdxs = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
						lockTemplate.LockNo = _this.FormEquip.EquipNo + LockIdxs[_this.FormEquip.ParkingLocks.length];
						lockTemplate.EquipNo = _this.FormEquip.EquipNo;

						_this.FormEquip.ParkingLocks.push({
							...lockTemplate
						})
					}
				
			},
			delLock() {
				this.FormEquip.ParkingLocks.pop();
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}
</style>
